module.exports = __webpack_public_path__ + "static/img/loginBg.10dca5c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/loginBg.png
// module id = u9fD
// module chunks = 1